"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMobileClasses = exports.createWrapperMedia = exports.isMobile = exports.media768 = exports.mobileThreshold = void 0;

var classnames_1 = __importDefault(require("classnames"));

exports.mobileThreshold = 768;
exports.media768 = "@media (max-width: " + exports.mobileThreshold + "px)";

function isMobile(responsive) {
  if (responsive === 'mobile') {
    return true;
  }

  if (responsive === 'desktop') {
    return false;
  }
  /* istanbul ignore next line */


  if (typeof window === 'undefined') {
    return false;
  }

  if (typeof window.matchMedia !== 'function') {
    return false;
  }

  return window.matchMedia("(max-width: " + exports.mobileThreshold + "px)").matches;
}

exports.isMobile = isMobile;

function createWrapperMedia(object) {
  var _a;

  var newObject = (_a = {}, _a[exports.media768] = {}, _a);
  Object.keys(object).forEach(function (el) {
    var _a;

    if (typeof object[el] !== 'object' || el === 'fallbacks') {
      newObject[exports.media768][el] = object[el];
      return;
    }

    newObject[el] = (_a = {}, _a[exports.media768] = object[el], _a);
  });
  return newObject;
}

exports.createWrapperMedia = createWrapperMedia;

function createMobileStyles(mobileStyles) {
  return {
    mobile: __assign({}, mobileStyles),
    auto: __assign({}, createWrapperMedia(mobileStyles))
  };
}

exports.default = createMobileStyles;

function createMobileClasses(_a) {
  var _b;

  var classes = _a.classes,
      responsive = _a.responsive;
  return classnames_1.default((_b = {}, _b[classes.mobile] = responsive === 'mobile', _b[classes.auto] = responsive === 'auto', _b));
}

exports.createMobileClasses = createMobileClasses;